(function () {
  function renderSwymWishlistPage(swat) {
    const empty_content = "<p>There are no products in your wishlist</p>";
    const container = document.querySelector(".js-wishlist-products");
    const shareButton = document.querySelector(".js-wishlist-share-button");
    const sharingPopup = document.querySelector(".js-sharing-popup");

    const searchParams = new URLSearchParams(window.location.search);
    const lid = searchParams.get("lid");

    async function renderPage(products, shared) {
      const rawResponses = await Promise.all(
        products.map((product) => {
          return fetch(
            `/products/${
              product.du.split("products/")[1].split("?")[0]
            }?view=ajax-product-card`
          );
        })
      );

      const responses = await Promise.all(rawResponses.map((rr) => rr.text()));

      const productCards = [];

      responses.forEach((res, idx) => {
        if (!res.includes("<!DOCTYPE html>")) {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = res;

          const productCard = wrapper.querySelector(".product-grid-item");
          if (!productCard) return;

          const wishListIcon = productCard.querySelector(".cs-wishlist-button");
          if ( wishListIcon ) {
            if (!shared) {
              wishListIcon.innerHTML = `
                  <svg width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <path vector-effect="non-scaling-stroke" d="M0.309,0.309a0.9,0.9,0,0,1,1.268,0L63.691,62.423a0.9,0.9,0,0,1-1.268,1.268L0.309,1.577A0.9,0.9,0,0,1,.309.309Z"></path>
                    <path vector-effect="non-scaling-stroke" d="M63.691,0.309a0.9,0.9,0,0,1,0,1.268L1.577,63.691A0.9,0.9,0,0,1,.309,62.423L62.423,0.309A0.9,0.9,0,0,1,63.691.309Z"></path>
                  </svg>
                `;

              const productData = products[idx];
              const product = {
                epi: productData.epi,
                empi: productData.empi,
                du: productData.du,
              };

              wishListIcon.addEventListener("click", () => {
                swat.deleteFromList(productData.lid, product, () => {
                  productCard.parentElement.removeChild(productCard);
                  if (container.children.length === 0) {
                    container.classList.remove("--grid");
                    container.innerHTML = empty_content;
                  }
                });
              });
            } else {
              wishListIcon.parentElement.removeChild(wishListIcon);
            }
          }

          productCards.push(productCard);
          const epi = products[idx].epi;
          productCard.querySelectorAll("select").forEach((select) => {
            const options = select.querySelectorAll("option");
            const option = Array.from(options).find(
              (option) => `${option.value}` === `${epi}`
            );
            if (option) {
              select.value = option.value;
              select.dispatchEvent(new Event("change"));
            }
          });
        }
      });

      container.innerText = "";
      if (productCards.length) {
        container.classList.add("--grid");
        productCards.forEach((pc) => {
          container.appendChild(pc);
        });

        window.reinitReviews();

        if (shareButton.dataset.customerId && !shared) {
          shareButton.style.display = "block";
          shareButton.addEventListener("click", () => {
            shareButton.setAttribute("data-loading", "true");
            const lid = products[0]?.lid;
            if (!lid) return;
            swat.markListPublic(
              lid,
              () => {
                const url = window.location.host + "/pages/wishlist?lid=" + lid;

                const emailShare =
                  sharingPopup.querySelector(".js-email-share");
                emailShare.href = `mailto:?subject=Check out my wishlist!&body=Take a look at the items I have added to my wishlist:%0D%0A%0D%0A${url}`;

                const linkShare = sharingPopup.querySelector(".js-link-share");
                linkShare.addEventListener("click", (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  navigator.clipboard.writeText(url);
                  const sharingLink =
                    sharingPopup.querySelector(".js-sharing-link");
                  sharingLink.innerText = "Copied to the clipboard!";
                });

                sharingPopup.setAttribute("data-active", "true");
                document.documentElement.style.overflowY = "hidden";
                const closeBtn = sharingPopup.querySelector(
                  ".js-sharing-popup-close"
                );
                window.addEventListener("click", (e) => {
                  const target = e.target;
                  if (
                    target.contains(sharingPopup) ||
                    closeBtn.contains(target)
                  ) {
                    sharingPopup.removeAttribute("data-active");
                    document.documentElement.style.overflowY = "unset";
                  }
                });

                shareButton.removeAttribute("data-loading");
              },
              () => {
                shareButton.removeAttribute("data-loading");
              }
            );
          });
        }

        swat.initializeActionButtons(".js-wishlist-page .js-wishlist-products");
      } else {
        container.innerHTML = empty_content;
      }
    }

    if (lid) {
      swat.fetchListDetails({ lid }, (details) => {
        renderPage(details.items || [], true);
      });
    } else {
      _swat.fetchWrtEventTypeET((products) => {
        renderPage(products);
      }, swat.EventTypes.addToWishlist);
    }
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(renderSwymWishlistPage);
})();
